import { Menu, MenuItem } from '@liveauctioneers/hammer-ui-core/menu';
import * as React from 'react';

import ShouldLogInContainer from '@/components/ShouldLogIn/ShouldLogInContainer';
import { useAppDispatch } from '@/redux/hooks';
import { openExcludeHouseModal } from '@/redux/modules/modal';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import noop from '@/utils/noop';

import { StyledMenuContainer, StyledMenuIcon, TriggerWrapper } from './helpers/excludePopupStyles';

export interface ExcludeFacetMenuProps {
    'data-testid'?: string;
    excludeByHouseId: (houseId: number) => void;
    isMobileView: boolean;
    optionId: number;
}

const ExcludeFacetMenu = ({
    'data-testid': dataTestId,
    excludeByHouseId,
    isMobileView,
    optionId,
}: ExcludeFacetMenuProps) => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();

    const showExcludeConfirmation = React.useCallback(async () => {
        if (isMobileView) {
            excludeByHouseId(optionId);
        } else {
            dispatch(openExcludeHouseModal(optionId));
        }
    }, [dispatch, excludeByHouseId, isMobileView, optionId]);

    return (
        <StyledMenuContainer
            data-testid={dataTestId}
            onClick={(event) => {
                event.stopPropagation();
            }}
        >
            <Menu
                menuPlacement={isMobileView ? 'left' : 'right'}
                menuSize="md"
                numberOfColumns={1}
                trigger={
                    <TriggerWrapper data-testid="exclude-facet-menu-trigger">
                        <StyledMenuIcon
                            size="sm"
                            style="fill"
                        />
                    </TriggerWrapper>
                }
            >
                <ShouldLogInContainer runFunction={showExcludeConfirmation}>
                    <MenuItem
                        onClick={noop}
                        primaryLabel={formatMessage('search_facet_add_exclusion')}
                    />
                </ShouldLogInContainer>
            </Menu>
        </StyledMenuContainer>
    );
};

export default ExcludeFacetMenu;
